import { useState } from "react";
import { Line } from "react-chartjs-2";
// Components
import { MainDiv, Header, Title, Span, OpenButton, OpenButtonImg } from "./styles";
import Graphic from "../../../graphic";
import NoDataComponent from "../../../noDataComponent";
// Assets
import ArrowUpImg from "../../../../../../assets/icons/ico_arrow_up_blue.svg";
import ArrowDownImg from "../../../../../../assets/icons/ico_arrow_down_blue.svg";

const MetricPlot = ({ data, title, subtitle, axisY, max, options }) => {
  const [showPlot, setShowPlot] = useState(false);

  const checkSomeValue = () => {
    const metricsArray = data.datasets[0].data;
    return metricsArray.some((value) => value !== null && !Number.isNaN(value));
  };

  return (
    <MainDiv>
      <Header>
        <Title>
          <Span>{title}</Span> {subtitle}
        </Title>
        <OpenButton onClick={() => setShowPlot(!showPlot)}>
          <OpenButtonImg src={showPlot ? ArrowUpImg : ArrowDownImg} alt="arrow-ico" />
        </OpenButton>
      </Header>
      {showPlot &&
        (checkSomeValue() ? (
          <Graphic Title={""} Type={Line} data={data} options={options} axisY={axisY} axisX={"Weeks"} max={max} />
        ) : (
          <NoDataComponent text="There are no metrics" />
        ))}
    </MainDiv>
  );
};

export default MetricPlot;
